import React from 'react'
import CollaborationTasks from '../components/collaborations/CollaborationTasks'
import Tabs, { TabButton } from '../components/tabs/Tabs'
import Collaborations from './Collaborations'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../redux-stores/store'
import { getFiltersQuery } from '../utils/helpers'

const CollaborationsNew: React.FC = () => {

    const {pathname} = useLocation();
    const collabFilters = useSelector((state: RootState) => state.collaborationTasks.filters);
    const navigate = useNavigate();

    const getTabsButtons = (): TabButton[] => {
        const tabButtons: TabButton[] = [
            {
                content: <span onClick={() => navigate({pathname: '/collaborations', search: getFiltersQuery({...collabFilters, page: 1})})} className="unset-all d-flex align-items-center justify-content-center gap-2">Collaborations </span>
            },
            {
                content: <span onClick={() => navigate({pathname: '/applications'})} className="unset-all d-flex align-items-center justify-content-center gap-2">Applications</span>
            },
        ];

        return tabButtons;
    }

    return (
        <div>
            <Tabs buttons={getTabsButtons()} buttonClass='px-3' defaultActiveTabIndex={(pathname === '/applications') ? 1 : 0}>
                <CollaborationTasks />
                <Collaborations />
            </Tabs>
        </div>
    )
}

export default CollaborationsNew